export const enrollmentConfirmation = {
  title: "Demande Envoyée avec Succès!",
  subtitle: "Nous avons reçu votre demande de préinscription. Nous vous contacterons bientôt pour poursuivre le processus d'admission.",
  
  nextStepsTitle: "Prochaines Étapes",
  steps: {
    step1: {
      title: "Révision de votre demande",
      description: "Notre équipe examinera les informations que vous avez fournies. Nous vous contacterons dans un délai maximum de 48 heures ouvrables."
    },
    step2: {
      title: "Visite guidée personnalisée",
      description: "Nous coordonnerons une visite de nos installations où vous pourrez découvrir notre méthodologie, notre équipe éducative et résoudre toutes vos questions."
    },
    step3: {
      title: "Processus d'inscription",
      description: "Si les deux parties sont d'accord et qu'il y a des places disponibles, nous procéderons à la formalisation de l'inscription."
    }
  },
  
  contactTitle: "Besoin de Nous Contacter?",
  contact: {
    phone: "Téléphone",
    email: "Email",
    address: "Adresse",
    hours: "Horaires",
    hoursValue: "Lundi à Vendredi, 8h45 - 14h00"
  },
  
  scheduleVisit: "Réserver une Visite",
  backToHome: "Retour à l'Accueil",
  
  note: "Si vous ne recevez pas de réponse dans les 48 heures, veuillez vérifier votre dossier spam ou nous contacter directement."
};